import { render, staticRenderFns } from "./SfHeaderNavigationItem.vue?vue&type=template&id=22df2950&"
import script from "./SfHeaderNavigationItem.vue?vue&type=script&lang=js&"
export * from "./SfHeaderNavigationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports